#import "../fragments/custom-field-fragment.graphql"

mutation UnarchiveCustomField($input: CustomFieldUndeleteInputs!) {
    undeleteCustomField(input: $input) {
        customField {
            ...CustomFieldFragment
        }
    }
}
